import { render, staticRenderFns } from "./volume-link.vue?vue&type=template&id=5b02a810&scoped=true&"
import script from "./volume-link.vue?vue&type=script&lang=js&"
export * from "./volume-link.vue?vue&type=script&lang=js&"
import style0 from "./volume-link.vue?vue&type=style&index=0&id=5b02a810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b02a810",
  null
  
)

export default component.exports